import { getUserPending, getUserSuccess, getUserFail } from "./userTicketSlice";
import { getuser } from "./utilities/userauth";
// import { useDispatch } from 'react-redux'

export const getuserinfo = () => async (dispatch) => {
  // const dispatch = useDispatch()
  try {
    dispatch(getUserPending());

    const user = await getuser();
    // console.log(user.data.data.payload, "i ama the user iof tyhe adata");
    const { _id, name, email } = user.data.data.payload;
    dispatch(getUserSuccess({ _id, name, email }));
  } catch (error) {
    dispatch(getUserFail(error));
  }
};
